import {
  collection,
  onSnapshot,
  query,
  orderBy,
  limit,
} from "firebase/firestore";
import { dbAML as db } from "../../../../backend/firebaseConfig";

export function subscribeExperianResponse(ownerEmail, checkId, onData) {
  if (!ownerEmail || !checkId) throw new Error("Missing ownerEmail/checkId");

  const colRef = collection(
    db,
    `AML Checks/${ownerEmail}/Checks/${checkId}/Experian Response`
  );

  // IMPORTANT: pick your real timestamp field name:
  // createdAt / createdTime / timestamp / decisionTime etc.
  // This must be a Firestore field that increases over time.
  const q = query(colRef, orderBy("createdAt", "desc"), limit(1));

  return onSnapshot(
    q,
    (snap) => {
      if (snap.empty) return onData(null);

      const docData = snap.docs[0].data();

      // Always pass INNER response to the UI
      const inner = docData?.response ?? docData ?? null;
      onData(inner);
    },
    (err) => {
      // console.error("subscribeExperianResponse error:", err);
      onData(null);
    }
  );
}
